<template>
    <footer id="footer">
        <div class="footer-wrap">
            <div :class="cpr_area_class"> 
                <p>Copyright © 2020 PXMart All Right Reserved<span>活動客服0800-089-860（週一至週五09:00~12:00、13:30~17:30，國定例假日除外）</span></p>
            </div>
            <div class="footer-media">
                <a target="_blank"  v-for="data in media_links" :href="data.href" :class="data.name"> 
                    <span class="img-wrap"> <img :src="data.img" alt="line-link"> </span> 
                </a>
                <!-- <a target="_blank" href="http://bit.ly/2ubfPKn"> <span class="img-wrap"> <img src="./assets/footer-02.svg" alt="ig-link"> </span> </a>
                <a target="_blank" href="http://bit.ly/2KKQvFn"> <span class="img-wrap"> <img src="./assets/footer-03.svg" alt="fb-link"> </span> </a>
                <a target="_blank" href="https://www.youtube.com/channel/UCREDuMP2Ta1Hj43ZqlPX6YA"> <span class="img-wrap"> <img src="./assets/footer-04.svg" alt="youtube-link"> </span> </a> -->
            </div>
        </div>
    </footer>
</template>
<script>


import img1 from '../assets/footer-01.svg';
import img2 from '../assets/footer-02.svg';
import img3 from '../assets/footer-03.svg';
import img4 from '../assets/footer-04.svg';


export default {
    data(){
        return {
            media_links: [
                {
                    name: "line",
                    href: "http://bit.ly/2KWIdpL",
                    img: img1
                },
                {
                    name: "ig",
                    href: "https://www.instagram.com/pxmart/?utm_source=%E5%85%A8%E5%BA%97%E5%8D%B0%E8%8A%B1&utm_medium=eventwebsite&utm_content=IG",
                    img: img2
                },
                {
                    name: "fb",
                    href: "https://www.facebook.com/pxmartchannel?utm_source=%E5%85%A8%E5%BA%97%E5%8D%B0%E8%8A%B1&utm_medium=eventwebsite&utm_content=FB",
                    img: img3
                },
                {
                    name: "youtube",
                    href: "https://www.youtube.com/channel/UCREDuMP2Ta1Hj43ZqlPX6YA",
                    img: img4
                }
            ]

        }
    },
    computed: {
        cpr_area_class(){

            return (this.$route.name=="recipe" || this.$route.name=="recipe-single")?"cpr-area black":"cpr-area";
        }
    },
    methods: {
        ga_func(class_name, name){
            $("body").on('click', class_name, function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
    },
    mounted(){
        this.media_links.forEach((obj, id)=>{
            this.ga_func("."+obj.name, "footer連結-"+obj.name);
        });
        console.log("footer!!")
    }
}
</script>

<style lang="sass">
*
    //border: 1px solid

footer#footer
    padding: 150px 50px
    padding-bottom: 20px
    // padding-bottom: 100px
    position: relative
    overflow: hidden
    @media (max-width: 768px)
        padding-top: 100px
    @media (max-width: 576px)
        padding-top: 30px
        padding-bottom: 30px
    &:after
        content: ""
        display: block
        width: 100vw
        height: 60px
        position: absolute
        bottom: 0
        left: 0
        opacity: 1
        background: rgba(0, 0, 0, 0.5)
        pointer-events: none
        z-index: -1
        background: linear-gradient(to top, rgba(black, 0.7) 30%, rgba(black, 0.01) 100%)
        transition: .3s
        @media (max-width: 768px)
            height: 60px
        @media (max-width: 576px)
            display: none
    .footer-wrap
        padding: 0 15px
        position: relative
        text-align: center
        width: 100vw
        text-align: center
        width: 100vw
        position: relative
        margin-left: -50vw
        //margin-top: 100px
        left: 50%
        padding-bottom: 15px
        .cpr-area
            color: white
            font-weight: 300
            font-size: 14px
            span
                display: block
        .cpr-area.black
            color: black
            font-weight: 400
        .footer-media
            position: absolute
            right: 50px
            top: 50%
    
            transform: translateY(-50%)
        .img-wrap
            width: 35px
            display: inline-block
            margin: 0 10px
            img
                width: 100%
                -webkit-transition: .2s
                -o-transition: .2s
                transition: .2s
                &:hover
                    -webkit-transform: scale(0.9)
                    -ms-transform: scale(0.9)
                    transform: scale(0.9)

@media (max-width: 1200px)
    footer#footer .footer-wrap .footer-media
        position: static
        -webkit-transform: translateY(0%)
        -ms-transform: translateY(0%)
        transform: translateY(0%)
        margin-top: 30px

@media (max-width: 400px)
    footer#footer .footer-wrap .footer-media .img-wrap
        margin: 0 5px

</style>



// WEBPACK FOOTER //
// src/subview/Footer.vue